import React, { useMemo, useState } from "react";
import { Column } from "primereact/column";
import { useTranslation } from "react-i18next";
import func from "../../../services/functions";
import editor, { BodyWrapper } from "../../PrimeTable/helper";
import moment from "moment";
import { toast } from "react-toastify";
import { DataTable } from "primereact/datatable";
import useSearchPurchase from "./useSearchPurchase";
import CellInput from "../../global/CellInput";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import { Dialog } from "primereact/dialog";
import PaymentPurchaseTable from "./SearchPurchaseTable";
import { calculatePaymentOrderData, mapPurchaseInvoice } from "./PaymentOrderUtils";
import bigDecimal from "js-big-decimal";

const SummaryPaymentTable = ({valid,defaultPaymentOrder,paymentOrder,setPaymentOrder,validationErrors={},setValidationErrors,disabled}) => {
  const { t } = useTranslation("translations");
  const defaultInvoice=useMemo(()=>({...defaultPaymentOrder[0]}),[])
  const {getFilteredResults,invoices:dropdownSuggestions} = useSearchPurchase()
  const [searchModal,setSearchModal] = useState({show:false})

  const caluculateInvoiceData=(state)=>{
    const {invoicesTotal } = calculatePaymentOrderData(paymentOrder);

    setPaymentOrder((paymentOrder)=>({
      ...paymentOrder,
      invoicesTotal
    }))
}

  React.useEffect(() => {
    caluculateInvoiceData()
  }, [
    ...paymentOrder.paymentOrderRecords.map((inv) => {
      const { amountInAll} = inv;
      return `${amountInAll}`;
    }),
  ]);

  
  const loadOptions = (searchQuery)=>{
    if(!searchQuery || searchQuery?.length==0) return []
    const data= {
      fromDate: func.getDateFromToday(-364),
      toDate: func.getDateFromToday(1),
      params:{
        docNumber:`<L>${searchQuery}<L>`,
        sellerTin:paymentOrder?.sellerNuis 
      }

    }
    return getFilteredResults({data})
  }


const addInvoice= ({newInvoice,rowIndex})=>{
  setPaymentOrder(paymentOrder=>{
      let paymentOrderRecords = [...paymentOrder.paymentOrderRecords]
      paymentOrderRecords= paymentOrderRecords.map((oldInvoice,index)=>{
        if(index == rowIndex){
          return mapPurchaseInvoice(newInvoice, paymentOrder.description)
        }
        return oldInvoice
      })
      return {
        ...paymentOrder,
        paymentOrderRecords
      }

  })
}

const summaryInvoiceCols = [
    {
    field: "docNumber",
    header: t(["invoice.docNumber"]),
    style: {minWidth:"200px",maxWidth:"220px"},
    body:(item,options)=><BodyWrapper parentKey={"paymentOrderRecords"} validate={true} item={item} options={options} errors={validationErrors}>{ item?.docNumber ?? ""}</BodyWrapper>,
    cellConfig:{
      type:"AUTOCOMPLETE",
      loadOptions:(searchQuery)=>loadOptions(searchQuery),
      suggestions:dropdownSuggestions,
      onSelect:({e,cellOptions})=>{addInvoice({newInvoice:e.value,rowIndex:cellOptions.rowIndex})}
    },
  },
  {
    field: "eInvoiceFic",
    header: t("invoice.FIC"),
    style: {minWidth:"200px",maxWidth:"220px"},
    body:(invoice)=><CellInput value={invoice?.eInvoiceFic ?? ""} width={200} />
  
  },
  {
    field: "dueDateTime",
    header: t("paymentOrder.dueDatePayOrder"),
    style: {minWidth:"180px",maxWidth:"180px"},
    body: invoice => invoice.dueDateTime ? moment(invoice.dueDateTime).format("DD/MM/YYYY") : "",
  },
  {
    field: "eInvoiceAmount",
    header: t("paymentOrder.invoiceAmount"),
    style: { minWidth: '160px', maxWidth: '160px' },
    body:(invoice)=> invoice.eInvoiceAmount ? func.getFormattedMoneyValue(invoice.eInvoiceAmount) : null
  },
  {
    field: "buyerPaidAmount",
    header: t("paymentOrder.paymentAmount"),
    style: { minWidth: '160px', maxWidth: '180px' },
    body:(item,options)=><BodyWrapper parentKey={"paymentOrderRecords"} validate={true} item={item} options={options} errors={validationErrors} showInputPlaceholder={!disabled}>{ item.buyerPaidAmount ? func.getFormattedMoneyValue(item.buyerPaidAmount) : 0}</BodyWrapper>,
    default:true,
    align:"right",
    cellConfig:{
        type: "number",
    },
  },
  {
    field: "openAmount",
    header: t("paymentOrder.openAmount"),
    style: {minWidth:"150px",maxWidth:"150px"},
    body:(invoice)=> invoice.buyerPaidAmount && invoice.eInvoiceAmount ?  func.getFormattedMoneyValue(bigDecimal.subtract(invoice.eInvoiceAmount,invoice.buyerPaidAmount)) : "0.00",
    align:"right",

  },
  {
    field: "purchaseWorkflowStatus",
    body:(invoice)=> invoice.purchaseWorkflowStatus,
    header: "Status Profisc",
    style: { minWidth: '130px', maxWidth: '130px' },
  },
  {
    field: "cisStatus",
    header: "Status CIS",
    style: { minWidth: '150px', maxWidth: '150px' },
  },
  {
    field: "description",
    header: t("paymentOrder.description"),
    style: { minWidth: '220px', maxWidth: '260px' },
    cellConfig:{
      type: "text",
      onChange: ({ cellOptions, value }) => {
        setPaymentOrder((paymentOrder) => ({
          ...paymentOrder,
          paymentOrderRecords: paymentOrder.paymentOrderRecords.map(pm=>({...pm,description:value}))
        }));
      },
    },
    body:(item,options)=><BodyWrapper parentKey={"paymentOrderRecords"} validate={false} item={item} options={options} errors={validationErrors} showInputPlaceholder={!disabled}>{ item?.description ?? ""}</BodyWrapper>,
  },
];

console.log({paymentOrder})
  const addNewItem = (e) => { 
    if (e) {
      e.preventDefault();
    }
    if (!valid({validateOnlyInvoicesFields:true})) {
      toast.error("Fix validations",{
        containerId: "all_toast",
      });
      return;
    }
    setPaymentOrder((paymentOrder)=>{ 
      return {
        ...paymentOrder,
        paymentOrderRecords:[... (paymentOrder.paymentOrderRecords?? []),defaultInvoice]
      }
    })
  };

  
  const removeItem = (e, item, index) => {
    e.preventDefault();
    if(index==0 && (paymentOrder.paymentOrderRecords??[]).length==1){
      setPaymentOrder((order)=>({...order,paymentOrderRecords:[...defaultPaymentOrder.paymentOrderRecords]}))
    }else{
    setPaymentOrder((paymentOrder) => {
      const newAcconts = (paymentOrder.paymentOrderRecords ?? []).filter((acc, i) => i !== index);
      return {
      ...paymentOrder,
      paymentOrderRecords: newAcconts,
    }});
    }

  };

    const removeItemColumn = (
      <Column
        body={(...props) => {
          const rowIndex = props?.[1]?.rowIndex;

          return (
            <div className="d-flex justify-content-between ">
              <div>
                  <i
                    onClick={(e) => removeItem(e, paymentOrder.paymentOrderRecords[rowIndex], rowIndex)} 
                    className="pi pi-trash trash"
                  ></i>
              </div>
            </div>
          );
        }}
        headerStyle={{ width: "50px", minWidth: "50px" }}
        bodyStyle={{
          textAlign: paymentOrder?.paymentOrderRecords?.length > 1 ? "center" : "left",
          width: "50px"

        }}
        alignFrozen="right"
        frozen={true}
      />
    );
  
    const addRows = (
      <Column
        body={(...props) => {
          const rowIndex = props?.[1]?.rowIndex;
          return (
            <div className="d-flex justify-content-between">
              <div>
                {rowIndex === paymentOrder?.paymentOrderRecords.length - 1 ? (
                  <i
                    className="pi pi-plus-circle plus"
                    onClick={() => {
                      addNewItem();
                    }}
                  ></i>
                ) : null}
              </div>
            </div>
          );
        }}
        headerStyle={{ width: "50px", minWidth: "50px" }}
        bodyStyle={{
          textAlign: paymentOrder?.paymentOrderRecords?.length > 1 ? "center" : "left",
          width: "50px"
        }}
        alignFrozen="right"
        frozen={true}
      />
    );
  
  


  const handleInvoicesChange = ({ cellOptions, key, value, length,unitDefault=false }) => {
        const index = cellOptions?.rowIndex ?? 0;
        if (index < 0) return;
        value = length != undefined ? value.slice(0, length) : value;
        const keys=key?.split(".")
        setPaymentOrder((paymentOrder) => {
          const content = {
            ...paymentOrder,
            paymentOrderRecords: [
              ...paymentOrder.paymentOrderRecords.map((oldInvoice, oldIndex) =>{
                if(oldIndex !== index){
                  return oldInvoice
                }
                  let newAcc
                  if(keys.length==1){
                    newAcc={
                    ...oldInvoice,
                    [keys[0]]: value
                    } 
                  }else if(keys.length==2){
                   newAcc={
                    ...oldInvoice,
                    [keys[0]]: {
                      ...(oldInvoice[keys[0]] ? {...oldInvoice[keys[0]]}:{}),
                      [keys[1]]: value,
                    },
                  }
                  }
                   return newAcc
              }
                

              ),
            ],
          }
          return content
        });
        return value;
      };
      

 const dynamicColumns = useMemo(()=>summaryInvoiceCols.map((col, i) => {
    const colProps = {
      menu:false,
      sortable:false,
      filter: false,
      showFilterMenu: false,
      ...col,
    };
    if (colProps?.hasEditor || colProps?.cellConfig){
      colProps.editor = (options) => editor({disabled,validationErrors,setValidationErrors, parentKey:"paymentOrderRecords",col, t,cellOptions: options,onChange: ({ key, value, cellOptions }) =>handleInvoicesChange({key, value, cellOptions }) });
    }

      return <Column key={colProps.field} {...colProps} />;
  }),[handleInvoicesChange,summaryInvoiceCols,paymentOrder?.paymentOrderRecords,getFilteredResults,editor,loadOptions]);

  const onSuccess = (invoices) =>{
    setPaymentOrder(payment=>{
      const addedInvoices= invoices.map(inv=>mapPurchaseInvoice(inv, payment.description) )
      return {
        ...payment,
        paymentOrderRecords:[
          ...(payment?.paymentOrderRecords?.length>1?(payment.paymentOrderRecords ?? []):[]),
          ...addedInvoices
        ]
      }
    })
    setSearchModal({show:false})
  }
  const header=(
    <>
    <button className="btn btn-sm btn-primary" onClick={()=>setSearchModal({show:true})} disabled={disabled}>
      <FontAwesomeIcon className="mr-2" icon={faSearch}/>
      <span>
        Select Invoices
      </span>
    </button>
    <Dialog
      visible={searchModal?.show}
      onHide={() => setSearchModal({show:false})}
      style={{ width: "80%",minHeight:500 }}
      breakpoints={{ "960px": "75vw", "641px": "100vw" }}
      closable={true}
    >
      {searchModal?.show && <PaymentPurchaseTable paymentOrder={paymentOrder} onSuccess={onSuccess} />}
    </Dialog>
    </>
  )


    return (
        <>
        <div className="d-flex flex-wrap justify-content-between align-items-center my-2 w-full">
          <DataTable
            scrollable
            scrollHeight="400px"
            editMode="cell"
            resizableColumns
            columnResizeMode="expand"  
            responsiveLayout="scroll"
            size="small"
            inline
            stripedRows
            item
            selectionMode="single"
            value={paymentOrder?.paymentOrderRecords ?? []}
            header={header}
            style={{ width: '100%' }}

          >
            { dynamicColumns }
            { !disabled && addRows }
            { !disabled && removeItemColumn }
    
          </DataTable>
        </div>

        </>
    )
};

export default SummaryPaymentTable;